import angular from "angular";
import uiRouter from "angular-ui-router";
import matchShotsIndividualVisualComponent from "./matchShotsIndividualVisual.component";

let matchShotsIndividualVisualModule = angular
  .module("matchShotsIndividualVisual", [uiRouter])
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state("match-profile.shotsIndividualVisual", {
      url: "/shotsIndividualVisual/:matchId/:leagueId/:olympicMatchId",
      component: "matchShotsIndividualVisual",
      data: { pageTitle: "ADD_SHOTS_INDIVIDUAL" },
      params: {
        matchId: { squash: true, value: null },
        olympicMatchId: { squash: true, value: null },
        leagueId: { squash: true, value: null },
      },
      resolve: {
        hasPermission: ($q, $rootScope, Permissions) => {
          "ngInject";
          let deferred = $q.defer();
          //   if (
          //     $rootScope.user.canDo(
          //       Permissions.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS
          //     )
          //   ) {
          deferred.resolve();
          //   } else {
          //     deferred.reject("Access Denied!!");
          //   }
          return deferred.promise;
        },
      },
    });
  })
  .component(
    "matchShotsIndividualVisual",
    matchShotsIndividualVisualComponent
  ).name;

export default matchShotsIndividualVisualModule;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchShotsIndividualVisual/matchShotsIndividualVisual.js